import { render, staticRenderFns } from "./PuzzleGrid.vue?vue&type=template&id=dfefea5c&scoped=true&"
import script from "./PuzzleGrid.vue?vue&type=script&lang=js&"
export * from "./PuzzleGrid.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleGrid.vue?vue&type=style&index=0&id=dfefea5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfefea5c",
  null
  
)

export default component.exports